import { RouteRecordRaw } from "vue-router";
import { LAYOUT } from "../constants";
import { ManagerType } from "../constants";

export default [
  {
    path: "/team",
    redirect: "/team",
    name: "Team",
    component: LAYOUT,
    meta: {
      order: 60,
      roles: [ManagerType.Unit, ManagerType.OrganizationReviewer],
      title: "队伍管理",
    },
    children: [
      {
        path: "",
        name: "TeamPage",
        component: () => import("@/views/team/TeamPage.vue"),
        meta: {
          title: "队伍管理",
          icon: "fluent:people-team-24-filled",
          roles: [ManagerType.Unit, ManagerType.OrganizationReviewer],
        },
      },
    ],
  },
  {
    path: "/joined",
    redirect: "/joined",
    name: "PlayerTeam",
    component: LAYOUT,
    meta: {
      order: 80,
      roles: ManagerType.Single,
      title: "加入的队伍",
    },
    children: [
      {
        path: "",
        name: "JoinedTeamPage",
        component: () => import("@/views/team/JoinedTeamPage.vue"),
        meta: {
          title: "加入的队伍",
          icon: "fluent:people-team-24-filled",
          roles: ManagerType.Single,
        },
      },
    ],
  },
] as RouteRecordRaw[];
